import { PrintType, Size, SizePx } from '@/types';
import { MM_PER_INCH } from '@/utils/math/consts';

export const ensureSizeMm = (size: Size | SizePx, printType: PrintType): Size =>
  size.unit === 'px' ? convertSizePxToSizeMm(size, printType) : size;

export const convertSizePxToSizeMm = ({ width, height }: SizePx, { dpi }: PrintType): Size => ({
  width: (width / dpi) * MM_PER_INCH,
  height: (height / dpi) * MM_PER_INCH,
  unit: 'mm',
});
